import { render, staticRenderFns } from "./BuyEditionPanel.vue?vue&type=template&id=4c3bc22c&scoped=true&"
import script from "./BuyEditionPanel.vue?vue&type=script&lang=js&"
export * from "./BuyEditionPanel.vue?vue&type=script&lang=js&"
import style0 from "./BuyEditionPanel.vue?vue&type=style&index=0&id=4c3bc22c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3bc22c",
  null
  
)

export default component.exports